import React from 'react';
import Region, { marketStateEnabledRegions } from '@app/model/market_state/Region';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import {
	useMarketStateFilterInputTools,
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import { REGION_DATA } from '@app/component/region/FindRegionData';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';

type DashboardSelectRegionFilterProps = {
	filter: MarketStateFilterInput,
	onFilter: (filter: MarketStateFilterInput) => void
}

const DashboardSelectRegionFilter = React.memo(
	function DashboardSelectRegionFilter({ filter, onFilter }: DashboardSelectRegionFilterProps) {
		const { isDashboardFilterEnabled } = useMarketStateFilterInputTools();
		const providerSupportsFilter = isDashboardFilterEnabled(CompanyHotelDashboardFilter.REGION);

		const menuItems = [
			...marketStateEnabledRegions.map(r => ({ name: REGION_DATA[r].name, value: r, icon:REGION_DATA[r].icon })),
		];

		const onSelect = (value: Region) => {
			onFilter({ ...filter, region: value });
		};

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValue={filter.region}
														 onSelect={onSelect}
														 menuDescription="Please select the region that will provide your results."
														 disabled={!providerSupportsFilter} />;
	},
);

export default DashboardSelectRegionFilter;